<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-12-15 13:36:57
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-15 16:01:44
 * @FilePath: \seller.sviptrader.com\src\views\teamManage\accountManage\components\checkDel\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :visible.sync="delDialog" width="400px" class="tipDialog">
		<div slot="title">
			提示
		</div>
		<div class="flex-row-align-center">
			<i class="el-icon-warning mr-6 mt-2 font-h2-regular " style="color: #ff7038"></i>
			<span class="ft-14">
				该账号下有未被交接的业务，请在“子账号管理”中或联
			</span>
		</div>
		<p class="ml-24 mt-6">系管理员及时交接相应业务后才可删除。</p>
		<span slot="footer" class="dialog-footer">
			<el-button @click="delDialog = false">取 消</el-button>
			<el-button type="primary" @click="confirm" v-auth="['system:managerUser:create']">前往交接</el-button>
		</span>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			delDialog: false,
			row: {},
		};
	},
	methods: {
		show(row) {
			this.row = row;
			this.delDialog = true;
		},
		async confirm() {
			this.$emit('openHandover', this.row);
			this.delDialog = false;
		},
	},
};
</script>
<style lang="'less'" scoped></style>
